import { Pipe, PipeTransform } from '@angular/core';
import { ImageSize } from '../enums/image/image-sizes.enum';
import { IImage } from '../models/image/image.model';

@Pipe({
  name: 'imageUrl',
  standalone: true
})
export class ImageUrlPipe implements PipeTransform {

  transform(image: IImage, preferredSize?: ImageSize, cache: boolean = true): string | null {

    let urlToReturn = null;

    if (preferredSize) {
      const url = image[preferredSize];
      if (url) urlToReturn = url;
    }

    for (let [size, url] of Object.entries(image)) {
      if (url) {
        urlToReturn = url;
        break;
      }
    }

    if (cache === false && urlToReturn) {
      urlToReturn += `?t=${new Date().getTime()}`;
    }

    return urlToReturn;
  }

}
